export const AUTH_REQUEST = 'users/AUTH_REQUEST';
export const AUTH_REQUEST_FAIL = 'users/AUTH_REQUEST_FAIL';
export const AUTH_RESPONSE = 'users/AUTH_RESPONSE';
export const AUTH_SIGNOUT = 'users/AUTH_SIGNOUT';
export const HIDE_MODAL = 'users/HIDE_MODAL';
